export default __webpack_public_path__ + "static/media/curso-por-internet.795b3036.png";